import { DealStepper, nothingToDoRightNow } from '@/components/deal-stepper/DealStepper';
import { ErrorState } from '@/components/ErrorState';
import { LastReported } from '@/components/LastReported';
import { SectionCard } from '@/components/SectionCard';
import { Text } from '@/components/Text';
import type { Action, Deal, DealCta, DealStep } from '@/types/deal';

export type DealProgressSectionProps = {
  deal: Deal;
  action: Action | undefined;
  onCtaPress: (step: DealStep, cta?: DealCta) => void;
  /** A click/advance is in flight. Passed in so the observer screen owns the store read. */
  ctaLoading: boolean;
  ctaError: string | null;
  /** The action can no longer change (paid, rejected, expired). */
  settled: boolean;
};

/**
 * "Your steps": everything about the user's run at this deal in one
 * section: the status card (what the brand confirmed, the next action), the
 * stepper, the idle line, and a CTA failure.
 */
export function DealProgressSection({
  deal,
  action,
  onCtaPress,
  ctaLoading,
  ctaError,
  settled,
}: DealProgressSectionProps) {
  return (
    <SectionCard title="Your steps" testID="deal-progress">
      <LastReported deal={deal} action={action} />

      <DealStepper
        deal={deal}
        action={action}
        onCtaPress={onCtaPress}
        ctaLoading={ctaLoading}
        blocked={deal.full && !action}
      />

      {!settled && nothingToDoRightNow(deal, action) && (
        <Text variant="caption" color="textMuted" testID="deal-idle-footer">
          You don't need to do anything right now. We'll update this page automatically.
        </Text>
      )}

      {ctaError && <ErrorState bare title="Couldn't continue" body={ctaError} />}
    </SectionCard>
  );
}
